import { clamp } from 'es-toolkit';
import { LngLatBounds } from 'maplibre-gl';
import type { RawCoordinates } from '../map-types';

export const extendBounds = (
  bounds: LngLatBounds,
  point: RawCoordinates
): LngLatBounds => {
  const { _sw: southWest, _ne: northEast } = bounds;

  return new LngLatBounds(
    {
      lng: southWest.lng - point.lng,
      lat: clamp(southWest.lat - point.lat, -90, 90)
    },
    {
      lng: northEast.lng + point.lng,
      lat: clamp(northEast.lat + point.lat, -90, 90)
    }
  );
};
